export default __webpack_public_path__ + "static/media/element_45.9a4bf1a6.webp";